import { ExposureEvent } from '@lib/flags/amplitude/ExposureEvent';
import { Flags } from '@lib/flags/flagConstants';
import { FooterLanguageMenu } from '@lib/types/cms/Footer';
import { getPageRootNode } from '@lib/util/getPageRootNode';
import { List } from 'phosphor-icons';
import { useState } from 'react';
import { FullscreenModal } from 'ui-components';
import { IconMenuOption } from '../../IconMenuOption';
import { isSaleLink } from '../common/saleNav';
import { NavigationItem } from '../types';
import MobileMenu from './MobileMenu';

type Props = {
  navigationItems: NavigationItem[];
  currencyAriaLabel?: string;
  microcopy: Record<string, string>;
  languageMenu?: FooterLanguageMenu;
};

export const MobileNavigationMenuModal = ({
  navigationItems,
  currencyAriaLabel = 'Currency',
  microcopy,
  languageMenu,
}: Props) => {
  const pageRootNode = getPageRootNode();
  const [isMobileNavMenuActive, setIsMobileNavMenuActive] = useState(false);
  // CPS-7434: the Sale item only becomes visible once the menu is opened, so
  // record exposure then rather than on every mobile pageview.
  const hasSaleLink = navigationItems.some((item) =>
    isSaleLink(item.mainLink.href)
  );

  const handleToggleMobileNavMenu = () => {
    setIsMobileNavMenuActive((prevMenuActive) => !prevMenuActive);
  };

  return (
    <>
      {isMobileNavMenuActive && hasSaleLink && (
        <ExposureEvent flagName={Flags.SALE_NAV_RED} />
      )}
      <IconMenuOption
        name={
          isMobileNavMenuActive
            ? microcopy['layout.close-menu'] || 'Close menu'
            : microcopy['layout.open-menu'] || 'Open menu'
        }
        onClick={handleToggleMobileNavMenu}
      >
        <List size={20} />
      </IconMenuOption>
      <FullscreenModal
        returnFocus
        isActive={isMobileNavMenuActive}
        closeLabel={microcopy['layout.close-menu'] || 'Close menu'}
        closeModal={handleToggleMobileNavMenu}
        portalDomNode={pageRootNode}
        className="lg:hidden"
      >
        <MobileMenu
          goBackMicrocopy={
            microcopy['layout.go-back-to-navigation'] ?? 'Go back to navigation'
          }
          items={navigationItems}
          languages={{
            mainLink: {
              value: microcopy['layout.languages'],
              href: '',
            },
            columns: [
              {
                items: languageMenu?.languages ?? [],
              },
            ],
          }}
          currencies={{
            mainLink: { value: currencyAriaLabel, href: '' },
            columns: [
              {
                items: [
                  { title: 'EUR', currencyCode: 'EUR' },
                  { title: 'USD', currencyCode: 'USD' },
                ],
              },
            ],
          }}
        />
      </FullscreenModal>
    </>
  );
};
